<template>
  <div class="row pr-5 pl-5 pt-5 mt-5">
    <div class="col">
      <h1 class>Admin Panel</h1>
      <p>
        This is where you add your admin stuff.
        <br />To make a user an admin, add them to the admin group
        <br />in the cognito user pool.
      </p>
    </div>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: "AdminPanel"
};
</script>